import { render, staticRenderFns } from "./TrashGroupHistorical.vue?vue&type=template&id=7ab7e180&scoped=true"
import script from "./TrashGroupHistorical.vue?vue&type=script&lang=js"
export * from "./TrashGroupHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab7e180",
  null
  
)

export default component.exports